<script>
import { mapActions } from 'vuex'
import { REMOTE_PATHS } from '@/constants/remote-paths.constant'
import { Message } from 'element-ui'

export default {
  methods: {
    ...mapActions('files', [
      'shareFilePromise'
    ]),
    ...mapActions('modal', [
      'setModalFile'
    ]),
    shareFileAction (file, kc) {
      if (file.shareLink) {
        const modal = kc ? 'shareKc' : 'share'
        this.setModalFile({ modal, file })
      } else {
        this.getShareLink(file, kc)
      }
    },
    getShareLink (file, kc) {
      this.shareFilePromise(file)
        .then(({ shortLink }) => {
          const link = `${REMOTE_PATHS.CLOUD_API_PATH}/shared_file/${shortLink}`
          file.shareLink = link
          this.shareFileAction(file, kc)
        }).catch(() => {
          Message({
            type: 'error',
            message: 'Oops, we were unable share this file',
            showClose: true
          })
        })
    }
  }
}
</script>
